import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentItrackStatus } from './normalize';

export const fetchShipmentItrackStatus = createProvider(api.fetchShipmentItrackStatus)
  .andThen((res) => normalizeShipmentItrackStatus(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
